const TrueCalendar = {
  _initialServerTimeMs: 0,
  _syncedAt: 0,

  updateTime(serverTimeMs) {
    this._initialServerTimeMs = serverTimeMs;
    this._syncedAt = Date.now();
  },

  getCurrentTime() {
    const elapsed = Date.now() - this._syncedAt;
    return this._initialServerTimeMs + elapsed;
  },

  get isSynced() {
    return this._initialServerTimeMs > 0;
  },
};

export default TrueCalendar;
